<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YxNZHk/tc-custom/9781646562145.jpg?1723405329911" alt="This image is the cover for the book The Circus Crown, The Talisman War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Circus Crown, The Talisman War
      </h1>
      <p class="bookDescription body article font2">
        <p>In the third installment of the Talisman Wars series, Dakota takes his teenage daughter Kenna on dangerous missions in an attempt to prevent the war from spreading. But an encounter with mutated monstrosities reveals a new and powerful enemy whose plans are as secretive as they are terrifying. <br/><br/>When Dakota goes missing, Kenna must step up and locate him at any cost. She relies on new and old friends to help her, but the responsibility to save him falls directly on her shoulders. Frantic, she travels across the country in search of her dad ... and is willing to kill anyone who gets in the way.<br/><br/>Can she find him before it's too late?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jaimie N. Schock
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e5ba582